import React, { useEffect, useState } from 'react';
import { icons } from 'utils/constants';
import { generatePreSignedUrl } from 'utils/helpers';
import './EventCardPoster.scss';

const EventCardPoster = ({ url, isS3UserURL, className, s3Path }) => {
  const [isImageError, setImageError] = useState(false);
  const [s3URL, setS3URL] = useState('');

  const fetchProfile = async (profileName) => {
    let retunURL = '';
    const response = await generatePreSignedUrl(profileName, s3Path);
    retunURL = response;
    setS3URL(retunURL);
  };

  useEffect(() => {
    if (url && isS3UserURL) {
      fetchProfile(url);
    } else {
      setS3URL(url);
    }
  }, [url, isS3UserURL, s3Path]);

  return (
    <div id="event-card-poster-container">
      <img
        src={isImageError ? icons.logo : s3URL || icons.logo}
        alt={'Event Poster'}
        className={className ? className : 'conference-img'}
        onError={() => setImageError(true)}
        loading="lazy"
      />
    </div>
  );
};

export default EventCardPoster;
